"use client"

import React from 'react';
import { Check } from "lucide-react";
import Image from 'next/image';
import { comparisonArray, packs } from '@/lib/constants';
import { useMediaQuery } from 'usehooks-ts';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ComparisonArrayDesktop = () => {

    return (
        <div className="w-full max-w-7xl mx-auto p-4 md:p-0">
            <div className="grid grid-cols-3">
                <div className="col-span-1"></div>
                <div className={`w-full text-white bg-${packs[0].color} flex justify-start items-center gap-4 py-2 px-4`}>
                    <Image src={packs[0].image} alt={packs[0].title} width={40} height={40} className={`aspect-square object-contain rounded bg-${packs[0].color}`} />
                    <div className="flex flex-col items-start">
                        <p className="font-semibold">{packs[0].title}</p>
                        <p className="text-sm">{packs[0].description}</p>
                    </div></div>
                <div className={`w-full text-white bg-${packs[1].color} flex justify-start items-center gap-4 py-2 px-4`}>
                    <Image src={packs[1].image} alt={packs[1].title} width={40} height={40} className={`aspect-square object-contain rounded bg-${packs[1].color}`} />
                    <div className="flex flex-col items-start">
                        <p className="font-semibold">{packs[1].title}</p>
                        <p className="text-sm">{packs[1].description}</p>
                    </div></div>
                {/* <div className={`w-full text-white bg-${packs[2].color} flex justify-start items-center gap-4 py-2 px-4`}>
                    <Image src={packs[2].image} alt={packs[2].title} width={40} height={40} className={`aspect-square object-contain rounded bg-${packs[2].color}`} />
                    <div className="flex flex-col items-start">
                        <p className="font-semibold">{packs[2].title}</p>
                        <p className="text-sm">{packs[2].description}</p>
                    </div>
                </div> */}
            </div>
            {comparisonArray.sections.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                    <h3 className="text-xl font-semibold bg-secondaryGreen text-start p-4 border-t">{section.title}</h3>
                    <div className="grid grid-cols-3">
                        {section.lines.map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                <div className="p-4 text-start bg-lightGreen border-t flex items-center gap-2">{line.title}{line.tooltip}</div>
                                <div className="flex justify-center items-center py-4 border-t">
                                    {line.standard.featured ? (
                                        <Check className="text-white bg-primaryGreen rounded-full p-1" />
                                    ) : (
                                        <span className="text-primaryGreen font-semibold">{line.standard.content}</span>
                                    )}
                                </div>
                                <div className="flex justify-center items-center py-4 border-t">
                                    {line.voip.featured ? (
                                        <Check className="text-white bg-primaryBlue rounded-full p-1" />
                                    ) : (
                                        <span className="text-primaryBlue font-semibold">{line.voip.content}</span>
                                    )}
                                </div>
                                {/* <div className="flex justify-center items-center py-4 border-t">
                                    {line.pro.featured ? (
                                        <Check className="text-white bg-primaryBlack rounded-full p-1" />
                                    ) : (
                                        <span className="text-primaryBlack font-semibold">{line.pro.content}</span>
                                    )}
                                </div> */}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

const ComparisonArrayMobile = () => {
    return (
        <div className="w-full max-w-7xl mx-auto p-4">
            <div className="grid grid-cols-3">
                {packs.map((pack, index) => (
                    <div
                        key={index}
                        className={`bg-${pack.color} text-white p-2 flex flex-col items-center justify-center text-center`}
                    >
                        <Image 
                            src={pack.image} 
                            alt={pack.title} 
                            width={40} 
                            height={40} 
                            className="aspect-square object-contain mb-2" 
                        />
                        <p className="text-sm font-semibold">{pack.title}</p>
                    </div>
                ))}
            </div>

            {/* Accordion Sections */}
            <Accordion type="single" collapsible className="w-full">
                {comparisonArray.sections.map((section, sectionIndex) => (
                    <AccordionItem key={sectionIndex} value={`section-${sectionIndex}`}>
                        <AccordionTrigger className="bg-secondaryGreen px-4 w-full hover:no-underline">
                            <h3 className="text-xl font-semibold">{section.title}</h3>
                        </AccordionTrigger>
                        <AccordionContent>
                            {section.lines.map((line, lineIndex) => (
                                <div key={lineIndex} className="border-t">
                                    <div className="bg-lightGreen p-4 flex items-center gap-2">
                                        {line.title}
                                        {line.tooltip}
                                    </div>
                                    <div className="grid grid-cols-3 border-t">
                                        <div className="flex justify-center items-center p-4">
                                            {line.standard.featured ? (
                                                <Check className="text-white bg-primaryGreen rounded-full p-1" />
                                            ) : (
                                                <span className="text-primaryGreen font-semibold text-sm">
                                                    {line.standard.content}
                                                </span>
                                            )}
                                        </div>
                                        <div className="flex justify-center items-center p-4">
                                            {line.voip.featured ? (
                                                <Check className="text-white bg-primaryBlue rounded-full p-1" />
                                            ) : (
                                                <span className="text-primaryBlue font-semibold text-sm">
                                                    {line.voip.content}
                                                </span>
                                            )}
                                        </div>
                                        {/* <div className="flex justify-center items-center p-4">
                                            {line.pro.featured ? (
                                                <Check className="text-white bg-primaryBlack rounded-full p-1" />
                                            ) : (
                                                <span className="text-primaryBlack font-semibold text-sm">
                                                    {line.pro.content}
                                                </span>
                                            )}
                                        </div> */}
                                    </div>
                                </div>
                            ))}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
};

export const ComparisonArray = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");

    return isMobile ? <ComparisonArrayMobile /> : <ComparisonArrayDesktop />
}